"use client"
import MainComponent from "@/components/reusableComponents/mainComponent"
import PdfRenderComponent from "./pdfRenderComponent"
import ArticleCard from "./articleCard"
import { useState } from "react"

interface ComponentProps {
  data: any
}

export default function ScientificDiscoveryPage({ data }: ComponentProps) {

  const [chosenPdf, setChosenPdf] = useState<string | null>(null)

  return (
    <MainComponent className="flex flex-col md:flex-row w-full px-4 md:px-16 gap-4 md:gap-8">

      <div className="w-full md:w-1/4 overflow-y-auto md:h-screen py-4 max-md:max-h-[200px]">
        {data.createPDF.map((article: any) => (
          <ArticleCard
            key={article.id}
            isActive={chosenPdf === article.pdf?.filename_disk}
            article={article}
            createdDate={data.date_created}
            setChosenPdf={setChosenPdf}
            chosenPdf={chosenPdf}
          />
        ))}
      </div>

      <div className="w-full md:w-3/4">
        <PdfRenderComponent chosenPdf={chosenPdf} />
      </div>

    </MainComponent>
  )
}
